import "./App.css";
import React, { useState } from "react";
import QUESTIONS from "./questionList";
import StartHeader from "./StartHeader";
import StartBtn from "./StartBtn";
import Questions from "./Questions";
import Score from "./Score";
import Result from "./Result";
import { useEffect } from "react";

function App() {
  const questionList = [
    QUESTIONS[0].question1,
    QUESTIONS[0].question2,
    QUESTIONS[0].question3,
    QUESTIONS[0].question4,
    QUESTIONS[0].question5,
  ];

  const [score, setScore] = useState(0);

  const [questionnumber, setQuestionNumber] = useState(0);

  const [start, setStart] = useState(false);

  const [progress, setProgress] = useState(false);

  const [result, setResult] = useState(false);

  const [question, setQuestion] = useState(questionList[questionnumber]);

  let answerCheck = (e) => {
    console.log(e.target.value);
    console.log(question.answer);

    e.preventDefault();

    if (questionnumber < 4) {
      if (e.target.value === question.answer) {
        setQuestionNumber(() => {
          return questionnumber + 1;
        });

        setScore(score + 1);

        console.log(questionnumber);
      } else {
        setQuestionNumber(() => {
          return questionnumber + 1;
        });

        console.log(questionnumber);
      }
    }

    if (questionnumber === 4) {
      if (e.target.value === question.answer) {
        setScore(score + 1);

        console.log(questionnumber);

        setProgress(false);
        setResult(true);
      } else {
        setProgress(false);
        setResult(true);

        console.log(questionnumber);
      }
    }
  };

  let resetQuiz = (e) => {
    setScore(0);
    setQuestionNumber(0);
    setStart(false);
    setProgress(false);
    setResult(false);
  }

  useEffect(() => {
    setQuestion(questionList[questionnumber]);
  }, [questionnumber]);

  useEffect(() => {
    return start === true ? setProgress(true) : setProgress(false);
  }, [start]);

  return (
    <div className="App">
      <div id="quiz">
        {start === false ? (
          <div>
            {" "}
            <div>
              <StartHeader />
            </div>
            <div>
              <StartBtn setStart={setStart} />
            </div>{" "}
          </div>
        ) : (
          ""
        )}

        {progress === true ? (
          <Questions
            answerCheck={answerCheck}
            question={question.question}
            option1={question.option1}
            option2={question.option2}
            option3={question.option3}
            option4={question.option4}
            answer={question.answer}
          />
        ) : (
          ""
        )}

        {progress === true ? (
          <div id="scoreboard">
            {" "}
            <Score score={score} />{" "}
          </div>
        ) : (
          ""
        )}

        {result === true ? <Result score={score} reset={resetQuiz} /> : ""}
      </div>
    </div>
  );
}

export default App;
